import React from 'react';
import { AccordionWrapper } from '../styles';
import AccordionButton from './AccordionButton';
import AccordionContent from './AccordionContent';
import { useConsolidatedNavContext } from 'src/providers/ConsolidatedNavContextProvider';
import {
  CAMPAIGN_MANAGER_TOOLBAR_ID,
  CC_MODAL_TOOLBAR_ID,
} from 'src/commons/constants';
import {
  NavigationAnnouncement,
  NAV_MIGRATION_ANNOUNCEMENT_ID,
} from '../NavigationAnnouncement';

interface AccordionProps {
  id: string;
  allToolsEnabled: boolean;
}

const Accordion: React.VFC<AccordionProps> = ({ id, allToolsEnabled }) => {
  const { isQuickNavModalEnabled, activeCategoryId, selectedNavItemId } =
    useConsolidatedNavContext();
  const isActive = id === activeCategoryId;
  const cbSelected =
    !isQuickNavModalEnabled && selectedNavItemId === CC_MODAL_TOOLBAR_ID;
  const isMergedCampaignManagerItem = id === CAMPAIGN_MANAGER_TOOLBAR_ID;

  const accordionButton = (
    <AccordionButton
      id={id}
      cbSelected={cbSelected}
      allToolsEnabled={allToolsEnabled}
    />
  );

  return (
    <AccordionWrapper isActive={isActive}>
      {isMergedCampaignManagerItem ? (
        <NavigationAnnouncement announcementId={NAV_MIGRATION_ANNOUNCEMENT_ID}>
          {accordionButton}
        </NavigationAnnouncement>
      ) : (
        accordionButton
      )}
      <AccordionContent
        id={id}
        cbSelected={cbSelected}
        allToolsEnabled={allToolsEnabled}
      />
    </AccordionWrapper>
  );
};

export default Accordion;
